export default __webpack_public_path__ + "static/media/TerminationRate.bc7a4031.svg";